import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';
import MailOutline from '@mui/icons-material/MailOutline';
import { CONTENT_MAX_WIDTH, TEXT_MAX_WIDTH, accentRuleSx, ctaSecondarySx } from '../styles/tokens';
import { INK, MUTED } from '../pages/Practice/map/mapTokens';
import { bandSx } from './home/homeUi';

const ContactSection = ({ tone }) => {
  return (
    <Box component="section" sx={bandSx(tone)}>
      <Box sx={{ maxWidth: CONTENT_MAX_WIDTH, mx: 'auto' }}>
        <Typography variant="h3" component="h2" fontWeight={900} color="primary.main" sx={{ mb: 1.5 }}>
          Contact us
        </Typography>
        <Box aria-hidden sx={{ ...accentRuleSx, mb: 3 }} />

        <Typography
          sx={{
            maxWidth: TEXT_MAX_WIDTH,
            mb: 4,
            fontSize: { xs: '1rem', md: '1.125rem' },
            lineHeight: 1.7,
            color: INK,
          }}
        >
          Have questions or feedback? We welcome anything constructive about our fide preparation materials — it is how
          this gets better.
        </Typography>

        <Button
          size="large"
          component={Link}
          to="/contact-us"
          variant="outlined"
          startIcon={<MailOutline />}
          sx={ctaSecondarySx}
        >
          Contact us
        </Button>

        <Typography sx={{ mt: 3, color: MUTED, fontSize: '0.875rem' }}>
          We typically respond within 2-3 business days.
        </Typography>
      </Box>
    </Box>
  );
};

export default ContactSection;
